import { render } from "./CreateNewRouting.vue?vue&type=template&id=8eb63dd6"
import script from "./CreateNewRouting.vue?vue&type=script&lang=js"
export * from "./CreateNewRouting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__